module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "FBMHD"
  }, [_vm._v("Contents")]), _vm._v(" "), _c('h2', {
    staticClass: "TOC-FBMHD"
  }, [_c('a', {
    attrs: {
      "href": "#/int"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('h2', {
    staticClass: "TOC-CH-T"
  }, [_c('a', {
    attrs: {
      "href": "#/c01"
    }
  }, [_vm._v("Essential Equipment")])]), _vm._v(" "), _c('h2', {
    staticClass: "TOC-CH-T"
  }, [_c('a', {
    attrs: {
      "href": "#/c02"
    }
  }, [_vm._v("General Techniques")])]), _vm._v(" "), _c('h2', {
    staticClass: "TOC-CH-T"
  }, [_c('span', {
    attrs: {
      "href": "#/c03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Finishing Techniques")])]), _vm._v(" "), _c('h2', {
    staticClass: "TOC-CH-T"
  }, [_c('span', {
    attrs: {
      "href": "#/c04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Knotting")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-AHD"
  }, [_c('span', {
    attrs: {
      "href": "#/c05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Knotting Basics")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-CH-AU"
  }, [_c('span', {
    attrs: {
      "href": "#/c06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Individual Knots")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-AHD"
  }, [_c('span', {
    attrs: {
      "href": "#/c06#Basic-Knots",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Basic Knots")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-AHD"
  }, [_c('span', {
    attrs: {
      "href": "#/c06#Chinese-Knots",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chinese Knots")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-AHD"
  }, [_c('span', {
    attrs: {
      "href": "#/c06#Flower-Knots",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Flower Knots")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-AHD"
  }, [_c('span', {
    attrs: {
      "href": "#/c06#Ring-Knots",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ring Knots")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-CH-AU"
  }, [_c('span', {
    attrs: {
      "href": "#/c07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Knotted Braids")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-AHD"
  }, [_c('span', {
    attrs: {
      "href": "#/c07#Basic-Knotted-Braids",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Basic Knotted Braids")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-AHD"
  }, [_c('span', {
    attrs: {
      "href": "#/c07#Switchback-Braids",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Switchback Braids")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-AHD"
  }, [_c('span', {
    attrs: {
      "href": "#/c07#Slip-Knot-Braids",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Slip Knot Braids")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-AHD"
  }, [_c('span', {
    attrs: {
      "href": "#/c07#Box-Braids",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Box Braids")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-AHD"
  }, [_c('span', {
    attrs: {
      "href": "#/c07#Beaded-Knotted-Braids",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Beaded Knotted Braids")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-CH-AU"
  }, [_c('span', {
    attrs: {
      "href": "#/c08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Macramé")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-AHD"
  }, [_c('span', {
    attrs: {
      "href": "#/c08#Macram--Basics",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Macramé Basics")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-AHD"
  }, [_c('span', {
    attrs: {
      "href": "#/c08#Square-Knot-Variations",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Square Knot Variations")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-AHD"
  }, [_c('span', {
    attrs: {
      "href": "#/c08#Multistrand-Macram-",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Multistrand Macramé")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-AHD"
  }, [_c('span', {
    attrs: {
      "href": "#/c08#Half-hitch-Variations",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Half-hitch Variations")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-AHD"
  }, [_c('span', {
    attrs: {
      "href": "#/c08#Adding-Beads-to-Macram-",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Adding Beads to Macramé")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-AHD"
  }, [_c('span', {
    attrs: {
      "href": "#/c08#Finishing-Techniques-for-Knotting",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Finishing Techniques for Knotting")])]), _vm._v(" "), _c('h2', {
    staticClass: "TOC-CH-T"
  }, [_c('span', {
    attrs: {
      "href": "#/c09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Braiding")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-CH-AU"
  }, [_c('span', {
    attrs: {
      "href": "#/c10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Plaiting")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-AHD"
  }, [_c('span', {
    attrs: {
      "href": "#/c10#Plaiting-with-Beads-and-Chain",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Plaiting with Beads and Chain")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-CH-AU"
  }, [_c('span', {
    attrs: {
      "href": "#/c11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Kumihimo")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-AHD"
  }, [_c('span', {
    attrs: {
      "href": "#/c11#Equipment-and-Materials",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Equipment and Materials")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-AHD"
  }, [_c('span', {
    attrs: {
      "href": "#/c11#Preparing-to-Braid",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Preparing to Braid")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-AHD"
  }, [_c('span', {
    attrs: {
      "href": "#/c11#Basic-Moves",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Basic Moves")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-AHD"
  }, [_c('span', {
    attrs: {
      "href": "#/c11#Round-Braids",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Round Braids")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-AHD"
  }, [_c('span', {
    attrs: {
      "href": "#/c11#Helix-Spiral-Braids",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Helix Spiral Braids")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-AHD"
  }, [_c('span', {
    attrs: {
      "href": "#/c11#Hollow-Braids",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hollow Braids")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-AHD"
  }, [_c('span', {
    attrs: {
      "href": "#/c11#Flat-Braids",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Flat Braids")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-AHD"
  }, [_c('span', {
    attrs: {
      "href": "#/c11#Woven-Flat-Braids",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Woven Flat Braids")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-AHD"
  }, [_c('span', {
    attrs: {
      "href": "#/c11#Beaded-Kumihimo-Braids",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Beaded Kumihimo Braids")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-AHD"
  }, [_c('span', {
    attrs: {
      "href": "#/c11#Working-with-Wire",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Working with Wire")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-AHD"
  }, [_c('span', {
    attrs: {
      "href": "#/c11#Finishing-Techniques-for-Braiding",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Finishing Techniques for Braiding")])]), _vm._v(" "), _c('h2', {
    staticClass: "TOC-CH-T"
  }, [_c('span', {
    attrs: {
      "href": "#/pro",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Projects")])]), _vm._v(" "), _c('h2', {
    staticClass: "TOC-FBMHD"
  }, [_c('span', {
    attrs: {
      "href": "#/sup",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Suppliers")])]), _vm._v(" "), _c('h2', {
    staticClass: "TOC-FBMHD"
  }, [_c('span', {
    attrs: {
      "href": "#/ack",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('h2', {
    staticClass: "TOC-FBMHD"
  }, [_c('span', {
    attrs: {
      "href": "#/cop",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Copyright")])]), _vm._v(" "), _c('h2', {
    staticClass: "TOC-FBMHD",
    attrs: {
      "id": "templates"
    }
  }, [_c('em', [_vm._v("All full-size templates can be found at")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "http://www.stitchcraftcreate.co.uk/patterns",
      "target": "_blank"
    }
  }, [_vm._v("www.stitchcraftcreate.co.uk/patterns")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-31f1d30c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/contents.vue
// module id = 60
// module chunks = 0